import { useState, useEffect } from "react";

import ModalPayment from "../../payment/ModalPayment";
import ProjectOffer from "./ProjectOffer";
import { FiChevronDown } from "react-icons/fi";
import { useDispatch, useSelector } from "react-redux";
import {
  getCardsList,
  getJobOffers,
  rejectJobOffer,
} from "../../../store/thunks";

/**
 * @typedef {Object} Props
 * @property {string} projectId
 */
const ProjectOffersSection = (/** @type {Props} **/ { projectId }) => {
  const dispatch = useDispatch();
  const [showOffers, setShowOffers] = useState(true);
  const { jobOffers, loading } = useSelector((state) => state.jobs);
  const [PaymentModalState, setPaymentModal] = useState(null);

  const handleRejectJobOffer = (offer) => {
    dispatch(rejectJobOffer(offer));
  };

  const handleAcceptJobOffer = async (offer) => {
    setPaymentModal({ ...offer, type: "job" });
  };

  useEffect(() => {
    dispatch(getJobOffers({ _id: projectId }));
    dispatch(getCardsList());
  }, [dispatch, projectId]);

  return (
    <>
      <div id="offers">
        <div
          className="offers-section"
          onClick={() => setShowOffers(!showOffers)}
        >
          <div className="d-flex justify-content-between align-items-center">
            <h5 className="mb-0">Offers</h5>
            <FiChevronDown />
          </div>
        </div>
        {showOffers && (
          <div className="offers-list" style={{ minHeight: "200px" }}>
            {jobOffers.length > 0 ? (
              jobOffers?.map((offer) => {
                return (
                  <ProjectOffer
                    key={offer._id}
                    data={offer}
                    onAccept={handleAcceptJobOffer}
                    onReject={handleRejectJobOffer}
                  />
                );
              })
            ) : jobOffers.length === 0 && !loading ? (
              <div className="d-flex align-items-center justify-content-center w-100 h-100">
                <p className="grey-clr text-center">No Offers to show</p>
              </div>
            ) : (
              loading && (
                <div className="d-flex align-items-center justify-content-center w-100 h-100">
                  <p className="grey-clr text-center">Loading...</p>
                </div>
              )
            )}
          </div>
        )}
      </div>
      <ModalPayment
        offer={PaymentModalState}
        isOpen={Boolean(PaymentModalState)}
        onClose={() => {
          setPaymentModal(null);
        }}
      />
    </>
  );
};

export default ProjectOffersSection;
